import React from "react";

export default function WattZapLogo({ variant = "full", entrance = true, height = 48, dark = true }) {
  const cls = entrance ? "wz-enter" : "wz-loop";
  return (
    <div className={`wz-logo ${cls}`} style={{ display: "inline-flex", alignItems: "center", gap: height * 0.35 }}>
      <style>{`
        .wz-logo .wz-wave { stroke-dasharray: 194; }
        .wz-enter .wz-wave { stroke-dashoffset: 194; animation: wzDraw 1.5s cubic-bezier(.65,0,.35,1) .15s forwards; }
        .wz-loop  .wz-wave { stroke-dashoffset: 0; }
        .wz-enter .wz-arc { opacity: 0; animation: wzRise .7s ease-out 1.05s forwards; }
        .wz-enter .wz-sun { transform-box: fill-box; transform-origin: center; transform: scale(0);
                            animation: wzPop .55s cubic-bezier(.34,1.56,.64,1) 1.35s forwards; }
        .wz-loop  .wz-sun { transform-box: fill-box; transform-origin: center; }
        .wz-enter .wz-t1 { opacity: 0; animation: wzFade .4s ease-out .15s forwards; }
        .wz-enter .wz-t2 { opacity: 0; animation: wzFade .4s ease-out 1.6s forwards; }
        .wz-logo .wz-spark { stroke-dasharray: 16 400; stroke-dashoffset: 16; opacity: 0;
                             animation: wzFlow 2.6s cubic-bezier(.45,.05,.55,.95) infinite; }
        .wz-enter .wz-spark { animation-delay: 2.2s; }
        .wz-loop  .wz-spark { animation-delay: .6s; }
        .wz-logo .wz-sunbeat { transform-box: fill-box; transform-origin: center;
                               animation: wzBeat 3s ease-in-out 2.6s infinite; }
        .wz-logo .wz-sunhalo { transform-box: fill-box; transform-origin: center; opacity: 0;
                               animation: wzPing 3s ease-out 2.6s infinite; }
        .wz-enter .wz-watt { opacity: 0; animation: wzUp .6s cubic-bezier(.2,.7,.3,1) 1.7s forwards; }
        .wz-enter .wz-zap  { opacity: 0; animation: wzUp .6s cubic-bezier(.2,.7,.3,1) 1.95s forwards; }
        .wz-loop .wz-watt, .wz-loop .wz-zap { opacity: 1; }
        .wz-logo .wz-word { font-family: 'Space Grotesk', sans-serif; font-weight: 600;
                            letter-spacing: .005em; line-height: 1; display: inline-flex; }
        .wz-logo .wz-zap { background: linear-gradient(90deg, #00D4FF, #21F59B);
                           -webkit-background-clip: text; background-clip: text; color: transparent; }
        @keyframes wzDraw { to { stroke-dashoffset: 0; } }
        @keyframes wzRise { from { opacity: 0; transform: translateY(4px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes wzPop  { to { transform: scale(1); } }
        @keyframes wzFade { to { opacity: 1; } }
        @keyframes wzUp   { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes wzFlow { from { stroke-dashoffset: 16; opacity: 1; } 90% { opacity: 1; }
                            to { stroke-dashoffset: -194; opacity: 0; } }
        @keyframes wzPing { 0% { transform: scale(1); opacity: .55; } 70% { transform: scale(2.1); opacity: 0; } 100% { opacity: 0; } }
        @keyframes wzBeat { 0%,100% { transform: scale(1); } 50% { transform: scale(1.12); } }
        @media (prefers-reduced-motion: reduce) {
          .wz-logo * { animation: none !important; }
          .wz-logo .wz-wave { stroke-dashoffset: 0; }
          .wz-logo .wz-arc, .wz-logo .wz-t1, .wz-logo .wz-t2, .wz-logo .wz-watt, .wz-logo .wz-zap { opacity: 1; }
          .wz-logo .wz-sun { transform: scale(1); }
          .wz-logo .wz-spark { opacity: 0; }
        }
      `}</style>
      <svg width={height} height={height} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"
           aria-label="WattZap logo" role="img">
        <defs>
          <linearGradient id="wzE" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0" stopColor="#00D4FF" /><stop offset="1" stopColor="#21F59B" />
          </linearGradient>
          <linearGradient id="wzS" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0" stopColor="#FFC857" /><stop offset="1" stopColor="#FFE29A" />
          </linearGradient>
          <filter id="wzG" x="-60%" y="-60%" width="220%" height="220%">
            <feGaussianBlur stdDeviation="3" result="b" />
            <feMerge><feMergeNode in="b" /><feMergeNode in="SourceGraphic" /></feMerge>
          </filter>
        </defs>
        <path className="wz-arc" d="M33 13 A23 23 0 0 1 67 13" fill="none" stroke="url(#wzS)" strokeWidth="6" strokeLinecap="round" />
        <path className="wz-wave" d="M16 56 H25 L36 82 L50 24 L64 82 L75 56 H84" pathLength="194" fill="none"
              stroke="url(#wzE)" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" filter="url(#wzG)" />
        <path className="wz-spark" d="M16 56 H25 L36 82 L50 24 L64 82 L75 56 H84" pathLength="194" fill="none"
              stroke="#FFFFFF" strokeWidth="5.5" strokeLinecap="round" strokeLinejoin="round" />
        <circle className="wz-sunhalo" cx="50" cy="24" r="7" fill="none" stroke="#FFC857" strokeWidth="2.5" />
        <g className="wz-sun"><circle className="wz-sunbeat" cx="50" cy="24" r="7" fill="#FFC857" /></g>
        <circle className="wz-t1" cx="6.5" cy="56" r="4.5" fill="none" stroke="#00D4FF" strokeWidth="3.4" />
        <circle className="wz-t2" cx="93.5" cy="56" r="4.5" fill="none" stroke="#21F59B" strokeWidth="3.4" />
      </svg>
      {variant === "full" && (
        <span className="wz-word" style={{ fontSize: height * 0.58 }}>
          <span className="wz-watt" style={{ color: dark ? "#FFFFFF" : "#111827" }}>Watt</span>
          <span className="wz-zap">Zap</span>
        </span>
      )}
    </div>
  );
}
